import { useEffect, useState } from "react";
import { MedpaxLogo } from "./MedpaxLogo";

const links = [
    { href: "#about", label: "About" },
    { href: "#products", label: "Products" },
    { href: "#contact", label: "Contact" },
];

export const Nav = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-white/85 backdrop-blur-md border-b border-[var(--line)]"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    className="text-[var(--ink)] inline-flex items-center gap-2.5"
                >
                    <MedpaxLogo markSize={28} />
                </a>
                <nav className="hidden md:flex items-center gap-10 text-sm text-[var(--ink)]">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="nav-link"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <a
                    href="#contact"
                    data-testid="nav-cta-contact"
                    className="hidden sm:inline-flex items-center h-9 px-4 text-sm bg-[var(--ink)] text-white hover:bg-[var(--ink-line)] transition-colors rounded-none"
                >
                    Get in touch
                </a>
            </div>
        </header>
    );
};
